// frontend/src/components/consultation/updated/popups/items/LanguageRow.tsx
import React from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '../../../../general/inputs/Button';

interface Props { 
    icon: React.ReactNode; 
    title: string; 
    handler: () => void; 
    isActive: boolean; // Accept the active state as a prop
}; 

const LanguageRow: React.FC<Props> = ({ icon, title, handler, isActive }) => {
    const { t } = useTranslation();     
    const colors = useAppSelector(state => state.theme.colors); 

    return (
        <Box
            onClick={!isActive ? handler : undefined} // Disable click if already active
            sx={{ 
                display: 'flex',
                cursor: isActive ? 'default' : 'pointer', 
                flexDirection: 'row', 
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 1, 
                width: '95%',
                borderRadius: 2, 
                padding: 1, 
                fontSize: 14, 
                borderWidth: isActive ? 1 : 0,
                borderStyle: 'solid', 
                borderColor:  isActive ? colors?.main : 'transparent', 
                '&:hover': { backgroundColor: isActive ? 'transparent' : colors?.sectionHover }
            }}
        >
            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >
                {icon}
                <Box sx={{ marginLeft: 1, color: colors?.text }}>{title}</Box>
            </Box>

            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >
                {isActive ? (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center', 
                            width: 100, 
                            height: 30,
                            borderRadius: 1, 
                            backgroundColor: 'rgba(180, 180, 180, 0.6)'
                        }}
                    >
                        {t('current')}
                    </Box>
                ) : (
                    <Button 
                        title={'select'}
                        triggerFunction={handler}
                        extraStyle={{ width: 100, margin: 0 }}
                    />
                )}
            </Box>
        </Box>
    );
};

export default LanguageRow;